import Bowser from 'bowser'

// TODO: Отказаться от использования userAgent https://ddinvest.atlassian.net/browse/IFA-282
export const getPlatformType = () => Bowser.parse(window.navigator.userAgent).platform.type
